
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const SEARCH_ACTION_TYPE = createActionTypes('search/SEARCH');
export const SEARCH_OBJECT = 'search/SEARCH_OBJECT';
export const CLEAR = 'search/CLEAR';
export const GET_PARAMS_VALUES = 'search/GET_PARAMS_VALUES';
export const SELECT_OBJECT_TYPE = 'search/SELECT_OBJECT_TYPE';
export const SET_SEARCH_PARAM = 'search/SET_SEARCH_PARAM';

export default function getActions(dispatch) {
    return {
        clear: () => dispatch({
            type: CLEAR
        }),
        getParamsValues: (token, katuzeKod, isknDate) => dispatch({
            type: GET_PARAMS_VALUES,
            katuzeKod, isknDate,
            operation: GET_PARAMS_VALUES
        }),
        searchObject: (token, objectType, katuzeKod, isknDate, params) => dispatch({
            type: SEARCH_OBJECT,
            token, objectType, katuzeKod, isknDate, params,
            operation: SEARCH_OBJECT,
        }),
        selectObjectType: (objectType) => dispatch({
            type: SELECT_OBJECT_TYPE, objectType
        }),
        setSearchParam: (objectType, name, value) => dispatch({
            type: SET_SEARCH_PARAM, objectType, name, value
        })
    };
}

function* workGetParamsValues(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: SEARCH_ACTION_TYPE.DEFAULT});
        yield put({type: SEARCH_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: SEARCH_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, SEARCH_ACTION_TYPE);
    }
}

function* workSearchObject(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: SEARCH_ACTION_TYPE.DEFAULT, operation: action.operation, objectType: action.objectType});
        yield put({type: SEARCH_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: SEARCH_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, SEARCH_ACTION_TYPE);
    }
}

export function* watchGetParamsValues(options) {
    yield takeEvery(GET_PARAMS_VALUES, workGetParamsValues, options, 'Načítání parametrů');
}

export function* watchSearchObject(options) {
    yield takeEvery(SEARCH_OBJECT, workSearchObject, options, 'Vyhledávání objektů');
}
